export const useWhatsAppButtonState = () => {
  const globalStore = useGlobalStore()
  const flagsReady = inject('flagsReady') as Ref<boolean>

  const isVisible = computed(() => {
    if (!flagsReady.value) {
      return false
    }

    if (!globalStore.isCheckoutEnabled) {
      return true
    }

    return globalStore.store.checkoutSettings?.isWhatsAppButtonEnabled
  })

  return {
    isVisible,
  }
}
